import { Check, Copy, QrCode, Share2 } from 'lucide-react'
import { QRCodeSVG } from 'qrcode.react'
import { useState } from 'react'
import { Button } from './ui'

const SHARE_TEXT = {
  xox: { title: 'Play XOX with me', text: 'Join my vanishing tic-tac-toe game' },
  ice: { title: 'Race me in Ice Ice Baby', text: 'Slide to the door before I do' },
  c4: { title: 'Play Connect Four with me', text: 'Four in a row, first to connect wins' },
  cycles: { title: 'Ride Light Cycles with me', text: 'Last cycle standing wins the round' },
} as const

export function InvitePanel({
  code,
  compact = false,
  path = '/r',
  game = 'xox',
}: {
  code: string
  compact?: boolean
  path?: string
  game?: keyof typeof SHARE_TEXT
}) {
  const url = `${location.origin}${path}/${code}`
  const [copied, setCopied] = useState(false)
  const [showQr, setShowQr] = useState(false)
  const canShare = typeof navigator.share === 'function'

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      setTimeout(() => setCopied(false), 1800)
    } catch {
      window.prompt('Copy this link', url)
    }
  }

  const share = async () => {
    try {
      await navigator.share({ ...SHARE_TEXT[game], url })
    } catch {
      // user dismissed the sheet
    }
  }

  return (
    <div className="flex flex-col gap-3">
      {!compact && (
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            Room code
          </div>
          <div className="select-all font-mono text-2xl font-bold tracking-[0.2em]">{code}</div>
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        {canShare && (
          <Button onClick={share}>
            <Share2 className="size-4" aria-hidden /> Invite a friend
          </Button>
        )}
        <Button variant={canShare ? 'secondary' : 'primary'} onClick={copy}>
          {copied ? (
            <Check className="size-4" aria-hidden />
          ) : (
            <Copy className="size-4" aria-hidden />
          )}
          {copied ? 'Copied!' : 'Copy link'}
        </Button>
        <Button variant="ghost" onClick={() => setShowQr((v) => !v)} aria-pressed={showQr}>
          <QrCode className="size-4" aria-hidden /> QR
        </Button>
      </div>
      {showQr && (
        <div className="self-start rounded-2xl bg-white p-3 ring-1 ring-slate-200">
          <QRCodeSVG value={url} size={160} marginSize={0} />
        </div>
      )}
    </div>
  )
}
